const RefreshBtnV2 = (props) => {
    return (
        <div className={"review-start-v2"} onClick={props?.refresh}>
                <button className={`review-start-v2-btn`}>
                    {("refresh")}
                </button>
        </div>
    );
};

export default RefreshBtnV2;
